var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color,"x-small":_vm.xs,"small":_vm.sm,"large":_vm.lg,"x-large":_vm.xl,"text-color":(_vm.textColor) ? _vm.textColor : undefined,"filter":""},on:{"click":_vm.emitClicked}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }